import { IconVariants } from '@uikit/components/Icon/interfaces';

export const PRODUCT_OPTIONS_ORDER = ['combined', 'power', 'gas'] as const;

export const PRODUCT_BUTTON_ICONS: Record<
  (typeof PRODUCT_OPTIONS_ORDER)[number],
  IconVariants
> = {
  power: 'user/lightning',
  gas: 'user/energy-fire',
  combined: 'user/calculator',
};
